module.exports = __webpack_public_path__ + "static/media/nft-33.6a8b5495.jpg";